import React from 'react';
import styled from 'styled-components';
import { slate1, white } from '@engage/colors/base';
import { spaces } from '@engage/styles/spaces';
import { label10Caps } from '@engage/typography/font-styles';
import { ClassesCopy } from '@members/copy/copy.generated';
import { Classes } from '@members/copy/models.generated/Classes';

const AudioLabel: React.FC<React.PropsWithChildren<unknown>> = props => (
  <Container {...props}>
    <ClassesCopy id={Classes.AudioOnly} />
  </Container>
);

const Container = styled.div`
  ${label10Caps};
  color: ${white};
  width: fit-content;
  border-radius: ${spaces.xxxSmall}px;
  text-align: center;
  padding: ${spaces.tiny}px ${spaces.xxxSmall}px;
  background-color: ${slate1};
  cursor: default;
`;

export default AudioLabel;
